export const languageMixin = {
  props: {
    language: {
      type: String,
    },
    showAll: {
      type: Boolean,
      default: true,
    },
    username: {
      type: String,
      default: "USERNAME",
    },
    password: {
      type: String,
      default: "PASSWORD",
    },
    userUrlBase: {
      type: String,
    },
    proxyUrlBase: {
      type: String,
    },
  },
  methods: {
    isLanguage: function (language) {
      if (!this.language && this.showAll) {
        return true;
      }
      return this.language === language;
    },
  },
};
